import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { VendorsTab } from "../components/setup/VendorsTab";
import { CompanyTab } from "../components/setup/CompanyTab";
import { UsersTab } from "../components/setup/UsersTab";
import { AccountTab } from "../components/setup/AccountTab";
import { DataTab } from "../components/setup/DataTab";
import { QuickLinkTab } from "../components/setup/QuickLinkTab";
import { FabricatorsTab } from "../components/setup/FabricatorsTab";
import { LocationsTab } from "../components/setup/LocationsTab";
import { TallyTab } from "../components/setup/TallyTab";
import { ItemsTab } from "../components/setup/ItemsTab";

const TABS = [
  { id: "vendors", label: "Vendors", el: VendorsTab, perm: ["po_view", "grn_view"] },
  { id: "items", label: "Items", el: ItemsTab, perm: ["po_view"] },
  { id: "fabricators", label: "Fabricators", el: FabricatorsTab, perm: ["jobs_view"] },
  { id: "locations", label: "Locations", el: LocationsTab },
  { id: "company", label: "Company", el: CompanyTab, admin: true },
  { id: "users", label: "Users", el: UsersTab, admin: true },
  { id: "link", label: "PO link", el: QuickLinkTab, admin: true },
  { id: "data", label: "Data", el: DataTab, perm: ["export_all", "export_month"] },
  { id: "tally", label: "Tally", el: TallyTab, perm: ["tally"] },
  { id: "account", label: "My account", el: AccountTab },
];

export default function Setup() {
  const { isAdmin, can } = useAuth();
  const tabs = TABS.filter((t) => (!t.admin || isAdmin) && (!t.perm || t.perm.some(can)));
  const [tab, setTab] = useState(tabs[0].id);
  const Current = tabs.find((t) => t.id === tab)?.el || tabs[0].el;
  return (
    <div className="space-y-4" data-testid="setup-page">
      <div>
        <p className="mono-label text-brand">Masters &amp; settings</p>
        <h1 className="font-heading text-2xl font-bold tracking-tight sm:text-3xl">Setup</h1>
      </div>
      <div className="seg">
        {tabs.map((t) => (
          <button key={t.id} data-active={tab === t.id} onClick={() => setTab(t.id)} data-testid={`setup-tab-${t.id}`}>{t.label}</button>
        ))}
      </div>
      <Current />
    </div>
  );
}
